<script>
import { customerMethods, isTokenValid } from '@state/helpers'
export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      cartError: null,
    }
  },
  methods: {
    ...customerMethods,
    tryToAddToCart() {
      /// If invalid token timeout
      if (!isTokenValid()) {
        this.$router.push({
          name: 'logoutAndShowSessionTimeout',
        })
        return
      }

      this.addToCart(this.product)
        .then((response) => {
          if (this.$ga) {
            this.$ga.event('_trackEvent', 'Cart', 'AddToCart', this.product.code)
          }
          const items = [
            {
              item_id: this.product.code,
              item_name: this.product.name,
              price: parseFloat(this.product.price),
              currency: 'USD',
              quantity: 1
            }
          ]
          if (this.$gtag) {
            this.$gtag.event('add_to_cart', {
              currency: 'USD',
              value: parseFloat(this.product.price),
              items: items
            })
          }
          this.$router.push({ name: 'checkout' })
        })
        .catch((error) => {
          this.cartError = error
        })
    },
  },
}
</script>

<template>
  <div class="cardContainer productPanel">
    <div class="row">
      <div class="col-md-4 col-12">
        <img :src="product.image" />
      </div>
      <div class="col-md-8 col-12 productDescription">
        <div v-html="product.htmlDescription"></div>
        <template v-if="product.code !== '10300'">
          <span>${{ product.price }}</span>
          <BaseButton button-type="buttonPrimary" @click="tryToAddToCart">
            <span>
              Add to Cart
            </span>
          </BaseButton>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
